/** Copyright © 2013-2021 DataYes, All Rights Reserved. */

import styled from 'styled-components';

export const StyledRegister = styled.div`
  .dyc-register-main {
    > h2 {
      font-size: 16px;
      color: #333333;
      text-align: center;
      margin: 0 0 30px;
    }

    .ant-form-item {
      &.form-submit-wrapper {
        margin-top: -10px;
        font-size: 14px;

        .ant-checkbox-wrapper {
          font-size: 14px;
        }
      }
    }
  }
  .dyc-login-register-main {
    position: relative;
    padding: 40px 60px;

    .ant-form-item {
      &.form-check {
        margin-top: -7px;
        margin-bottom: -25px;
      }
      .ant-input-affix-wrapper {
        padding: 0 0 0 12px;
      }
      input {
        height: 42px;
        font-size: 14px;
        color: #333;
      }
      .ant-btn {
        height: 42px;
        width: 100%;
      }
      .code-send-btn {
        margin-right: -12px;
      }
      .ant-form-explain {
        position: absolute;
        bottom: -22px;
        font-size: 12px;
      }
    }

    .dyc-svg-icon {
      width: 14px;
      height: 14px;
    }
    .account-login-block {
      display: none;
    }
    .qrcode-login-block {
      height: 440px;
      display: flex;
      justify-content: center;
      align-items: center;
    }
    &.show-account-block {
      .account-login-block {
        display: block;
      }
      .qrcode-login-block {
        display: none;
      }
    }
  }
  .dyc-register-footer {
    margin-bottom: 10px;
    font-size: 14px;

    > a {
      float: right;
    }
  }
  .ant-popover-arrow {
    border: 1px solid #1283d5;
    border-width: 0 1px 1px 0;
    box-shadow: none;
  }

  .ant-popover-inner {
    border: 1px solid #1283d5;
    background: transparent;
    box-shadow: none;
  }

  .ant-popover-inner-content {
    background: rgba(255, 255, 255, 0.85);
    padding: 10px 20px;
    border-radius: 4px;

    h4 {
      font-size: 12px;
      color: #333333;
      text-align: left;
      margin: 5px 0;
      font-weight: bold;
    }

    ul {
      padding-left: 15px;
      margin: 0;
      list-style: disc;
    }

    li {
      font-size: 12px;
      color: #3f3f3f;
      text-align: left;
      line-height: 17px;
    }
  }
`;
